import { useState } from 'react'
import { useNavigation } from '../../../hooks'
import { defaultPage } from '../../../hooks/useNavigation/constants'
import type { RouterOutputType } from '../../../types'
import { Banner, Tabs } from '../../molecules'
import {
  ConnectToPrivateTable,
  CreatePrivateTable,
  Lobby,
  ProfileBlock,
} from '../../organisms'
import { lobbyTabs } from './constants'
import { currencyTab, currencyTabs, mainPage } from './index.css'

type TabsType = keyof typeof lobbyTabs | 'createPrivateTable'

export const MainLayout = (
  props: (
    | {
        type: 'mainPage'
        profileData: RouterOutputType['user']['getUser']
      }
    | {
        type: 'newTableTab'
      }
  ) & {
    onJoinNewTable: (table: { id: string; password: string | null }) => void
  },
) => {
  const { goToPage, currentPage } = useNavigation()
  const [currentTab, setCurrentTab] = useState<TabsType>(
    currentPage.page === 'main'
      ? currentPage.options.tab || defaultPage.options.tab
      : defaultPage.options.tab,
  )
  const [filter, setFilter] = useState(
    currentPage.page === 'main'
      ? {
          ...defaultPage.options,
          ...currentPage.options,
        }
      : defaultPage.options,
  )

  const onChangeTab = (tab: TabsType) => {
    setCurrentTab(tab)
    if (tab === 'COIN' || tab === 'TON' || tab === 'USDT') {
      setFilter((old) => ({
        ...old,
        tab,
      }))
    }
    if (props.type !== 'mainPage') {
      return
    }
    if (tab === 'connectToPrivateTable' || tab === 'createPrivateTable') {
      goToPage(tab)
      return
    }
    goToPage('main', {
      ...defaultPage.options,
      tab,
    })
  }

  // return (
  //   <ScrollContainer.Container>
  //     <div className={mainPage}>
  //       <ProfileBlock
  //         inviterUserId={props.inviterUserId}
  //         onGetUser={() => setIsUserLoaded(true)}
  //       />
  //       <ScrollContainer.Interceptor>
  //         {isUserLoaded ? (
  //           <Banner
  //             type='PLAY_WITH_FRIENDS_3'
  //             onClick={() => goToPage('createPrivateTable')}
  //           />
  //         ) : (
  //           <SubscribeToChannel />
  //         )}
  //       </ScrollContainer.Interceptor>
  //       <Tabs
  //         tabs={currencyName}
  //         selectedTab={defaultTab}
  //         classNameTabList={currencyTabs}
  //         classNameTab={currencyTab}
  //         onChange={(tab) => onChangeTab(tab)}
  //       />
  //       <ScrollContainer.Scrollable>
  //         {isUserLoaded ? props.children : 'Loading...'}
  //       </ScrollContainer.Scrollable>
  //     </div>
  //   </ScrollContainer.Container>
  // )

  return (
    <div className={mainPage}>
      {props.type === 'mainPage' ? (
        <>
          <ProfileBlock data={props.profileData} />
          <Banner
            type='PLAY_WITH_FRIENDS_3'
            onClick={() => onChangeTab('createPrivateTable')}
          />
        </>
      ) : null}

      <Tabs
        tabs={lobbyTabs}
        selectedTab={currentTab}
        classNameTabList={currencyTabs}
        classNameTab={currencyTab}
        onChange={(tab) => onChangeTab(tab)}
      />

      {currentTab === 'createPrivateTable' ? (
        <CreatePrivateTable onCreate={props.onJoinNewTable} />
      ) : currentTab === 'connectToPrivateTable' ? (
        <ConnectToPrivateTable
          onClickCreatePrivateTable={() => onChangeTab('createPrivateTable')}
          onClickJoin={props.onJoinNewTable}
        />
      ) : (
        <Lobby
          type='PUBLIC'
          filter={filter}
          onClickSit={props.onJoinNewTable}
          onFilterUpdate={setFilter}
        />
      )}
    </div>
  )
}
